import { registerFragment } from '@redwoodjs/web/apollo';

registerFragment(gql`
  fragment BillPurchaseOrderFragment on PurchaseOrder {
    id
    slug
    flagged
    status
    customFields
    currencyCode
    exchangeRate
    submittedAt
    salesTerms
    vendorPo
    receiveDate
    businessEntity {
      id
      name
    }
    buyer {
      id
      user {
        id
        fullName
      }
    }
    soldThroughSalesOrder {
      id
      slug
      status
      businessEntity {
        name
      }

      fulfilledByPurchaseOrders {
        id
        slug
        status
      }
    }
    bills {
      id
      status
      type
    }
    shipment {
      ...BillShipmentFragment
    }
    lineItems {
      ...LineItemAttributes
      lotUsed {
        unitsUsed
        weightUsed
      }
      billLineItem {
        id
        billId
        ledgerAccount {
          id
          accountName
          accountType
          accountNumber
        }
      }
    }
    expenses {
      ...ExpenseAttributes
      ...ExpenseFinanceEntities
    }
    documents {
      ...BillDocumentFragment
    }
  }
`);
